import React, { useState, useCallback, useMemo } from 'react';
import { arrayOf, shape, string, func } from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { MoreHoriz } from '@material-ui/icons';
import * as styles from './styles/styles.module.scss';
import CircleButton from '../CircleButton';
import moreIcon from '../../../../assets/images/icons/maps/more-green.svg';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const MenuPop = ({ items, variant }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = useCallback(idx => {
    return () => {
      handleClose();
      items[idx].callback();
    };
  });

  const variants = useMemo(
    () => ({
      default: {
        button: (
          <button
            className={styles.button}
            title={StringConstantsMixin.strings.MORE_OPTIONS}
            aria-haspopup="true"
            type="button"
            onClick={handleClick}
          >
            <MoreHoriz />
          </button>
        ),
        transformOrigin: {
          vertical: -36,
          horizontal: 156
        }
      },
      circle: {
        button: (
          <CircleButton className={styles.circleIcon} icon={moreIcon} title={StringConstantsMixin.strings.MORE_OPTIONS} onClick={handleClick} />
        ),
        transformOrigin: {
          vertical: -64,
          horizontal: 132
        }
      }
    }),
    []
  );

  const { button, transformOrigin } = variants[variant];

  return (
    <div>
      {button}
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose} transformOrigin={transformOrigin}>
        {items.map((item, idx) => {
          const key = item.label.replace(' ', '_');
          return (
            <MenuItem key={key} onClick={handleMenuItemClick(idx)} classes={{ root: styles.menuItemRoot }}>
              {item.label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

MenuPop.propTypes = {
  items: arrayOf(
    shape({
      label: string,
      callback: func
    })
  ),
  variant: string
};

MenuPop.defaultProps = {
  items: [],
  variant: 'default'
};

export default MenuPop;
